import { VerbEnum } from '../../tracker/enums';
import useLazyTrack from './useLazyTrack';

type UsePageViewTracker = {
  trackPageView: (actorType: string, source: string, clientId: string) => void;
};

function usePageViewTracker(): UsePageViewTracker {
  const track = useLazyTrack();

  const trackPageView = (
    actorType: string,
    source: string,
    clientId: string,
  ) => {
    track(
      'Page viewed',
      {
        actor: {
          user_id: clientId,
          type: actorType,
          role: '',
        },
        object: {
          path: window.location.pathname,
          url: window.location.href,
        },
        context: {
          source,
        },
        verb: VerbEnum.VIEW,
      },
      'page',
    );
  };

  return { trackPageView };
}

export default usePageViewTracker;
